module.exports = __webpack_public_path__ + "static/media/GAP.1893c173.pdf";